import { useCallback } from 'react';

import { FilterNumberRangeProps } from './FilterNumberRange.types';

export const useFilterNumberRange = (
    filter: FilterNumberRangeProps['filter'],
    onFilterChange: FilterNumberRangeProps['onFilterChange']
) => {
    const handleChangeGreaterOrEqual = useCallback(
        (value: number | null) => {
            onFilterChange({
                ...filter,
                greaterOrEqual: value,
            });
        },
        [filter, onFilterChange]
    );

    const handleChangeLessOrEqual = useCallback(
        (value: number | null) => {
            onFilterChange({
                ...filter,
                lessOrEqual: value,
            });
        },
        [filter, onFilterChange]
    );

    const handleBlurGreaterOrEqual = useCallback(() => {
        let lessOrEqual = filter.lessOrEqual;
        let greaterOrEqual = filter.greaterOrEqual;

        if (greaterOrEqual && lessOrEqual && greaterOrEqual > lessOrEqual) {
            onFilterChange({
                ...filter,
                lessOrEqual: greaterOrEqual,
            });
        }
    }, [filter, onFilterChange]);

    const handleBlurLessOrEqual = useCallback(() => {
        let lessOrEqual = filter.lessOrEqual;
        let greaterOrEqual = filter.greaterOrEqual;

        if (greaterOrEqual && lessOrEqual && lessOrEqual < greaterOrEqual) {
            onFilterChange({
                ...filter,
                greaterOrEqual: lessOrEqual,
            });
        }
    }, [filter, onFilterChange]);

    return {
        handleChangeGreaterOrEqual,
        handleBlurGreaterOrEqual,
        handleChangeLessOrEqual,
        handleBlurLessOrEqual,
    };
};
